import { AppBar, TitlePortal } from 'react-admin';
import { Box } from '@mui/material';

const CustomAppBar = () => (
    <AppBar
        color="primary"
        sx={{
            '&.MuiAppBar-colorPrimary': {
                backgroundColor: '#0176BC',
            },
            boxShadow: '0 2px 8px rgba(1,118,188,0.25)',
        }}
    >
        <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
            <img
                src="/velora_blanco.png"
                alt="Velora"
                style={{ height: 35, display: 'block' }}
            />
        </Box>
        {/* Por defecto es un h6 (unos 18,5 px y peso 600 con este tema); con Poppins quedaba grande. */}
        <TitlePortal sx={{ fontSize: '15px', fontWeight: 500 }} />
    </AppBar>
);

export default CustomAppBar;
